<script setup lang="ts">
export interface VydavkyProps {
  druh: ProjektRozpocetPolozkaDruhVydavkuEnum
}

import { ProjektRozpocetPolozkaDruhVydavkuEnum } from '/@src/client-portal'
import { inject, computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<VydavkyProps>()

const { t } = useI18n()

const specResponse = inject('specResponse')

const vydavky = computed(() => {
  return specResponse?.zoppmSpec?.vyzvaZoppmRozpocetSpec?.vydavkySpec?.find(
    (skupinaVydavkov) => skupinaVydavkov.druhVydavku === props.druh
  )
})
</script>

<template>
  <template v-if="vydavky?.povolene">
    <IDSKHeading as="h2" variant="l">{{
      t(`zoppm.step9.${props.druh}.heading`)
    }}</IDSKHeading>
    <IDSKAccordion :section-expanded="0" :show-controls="false">
      <VydavkySkutocne
        v-for="(kategoria, pos) in vydavky.kategorieVydavkov"
        v-if="vydavky?.kategorieVydavkov?.length"
        :vydavky="vydavky"
        :kategoria="kategoria"
        :pos="pos"
      />
      <VydavkyZjednodusene
        v-else-if="vydavky?.zdrojeFinancovania?.length"
        :vydavky="vydavky"
      />
    </IDSKAccordion>
  </template>
</template>

<style lang="scss"></style>
